
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/display-advertising",
      function () {
        return require("private-next-pages/display-advertising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/display-advertising"])
      });
    }
  